import React, { useState } from 'react'
import { Button, Container } from 'react-bootstrap'
import QuestionsImg from '../assets/images/connect-agent-cta-icon.svg'
import ContactAgentModal from './ContactAgentModal'

function ConnectAgentCTA() {
    const [showContactModal, setShowContactModal] = useState(false);
    const handleShowContactModal = () => setShowContactModal(true);
    const handleCloseContactModal = () => setShowContactModal(false);
  return (
    <>
     <div className="connect-agent-cta common-padding">
      <Container>
        <div className='connect-agent-cta-wrap'>
          <img src={QuestionsImg} alt="" />
          <div className='text-wrap'>
            <h2>Get help finding an agent</h2>
            <p>We'll pair you with a Real Estate Premier Agent who has the inside scoop on your market.</p>
          </div>
          <Button className="custom-bttn style-3" onClick={(e) => { handleShowContactModal(); }}>Connect with an agent</Button> 
        </div>
      </Container>
     </div>
     <ContactAgentModal show={showContactModal} handleClose={handleCloseContactModal} />
    </>
  )
}
export default ConnectAgentCTA